import * as React from 'react';
import { IconButton, TooltipHost, mergeStyles } from '@fluentui/react';
import { sendErrorEvent } from '@fluidx/telemetry';
import { getAadTenant, getFileItemLite } from '@fluidx/utilities';
import { OfficeIconImage } from '../../assets/svgr/OfficeIcon';
import { useCancellableEffect } from '../../hooks/useCancellableEffect';
import { generateTooltipId } from '../../utilities/generateTooltipId';
import { containerToolbarButtonStyles } from './ContainerToolbarStyles';
// Styles for the OfficeIconImage SVG component
const iconStyle = mergeStyles({
    width: 20,
    objectFit: 'cover'
});
export const OfficeNavButton = /*#__PURE__*/ React.memo(function OfficeButton(props) {
    const { title , fileInfoPromise , logger , tokenProvider  } = props;
    const [url, setUrl] = React.useState(undefined);
    const header = 'https://www.office.com/launch/fluid/content?auth=2&';
    function constructFileUrlFromFileInfo(fileInfo) {
        const siteUrl = 'siteUrl=' + fileInfo.siteUrl.replace(/\//g, '%2F');
        const driveId = 'drive=' + fileInfo.driveId.replace(/\//g, '%2F');
        const item = 'item=' + fileInfo.fileId;
        getFileItemLite(tokenProvider, fileInfo.siteUrl, fileInfo.driveId, fileInfo.fileId, logger, getAadTenant(fileInfo.siteUrl, logger)).then((fileItem)=>{
            if (fileItem) {
                const file = 'file=' + fileItem.webDavUrl.replace(/\//g, '%2F').replace(/%20/g, '%2520');
                setUrl(header + siteUrl + '&' + driveId + '&' + item + '&' + file + '%3Fweb%3D1');
            }
        }).catch((error)=>{
            sendErrorEvent(logger, {
                eventName: 'EnableOfficeNavButtonError'
            }, error);
        });
    }
    useCancellableEffect((cancel)=>{
        Promise.race([
            cancel,
            fileInfoPromise.then((fileInfo)=>{
                constructFileUrlFromFileInfo(fileInfo);
            })
        ]).catch(()=>{});
    }, [
        fileInfoPromise
    ]);
    const tooltipId = generateTooltipId();
    return /*#__PURE__*/ React.createElement(TooltipHost, {
        content: title,
        id: tooltipId
    }, /*#__PURE__*/ React.createElement(IconButton, {
        "aria-label": title,
        "aria-describedby": tooltipId,
        styles: containerToolbarButtonStyles,
        disabled: url === undefined,
        href: url,
        target: "_blank",
        rel: "noopener noreferrer"
    }, /*#__PURE__*/ React.createElement(OfficeIconImage, {
        className: iconStyle
    })));
}); // #cspell:ignore svgr
